import Big from 'big.js';
/* eslint-disable no-restricted-imports */
import { createSelectorCreator, lruMemoize } from 'reselect';

export const defaultSelectorCreator = createSelectorCreator(
  {
    devModeChecks: {
      inputStabilityCheck: 'never',
      identityFunctionCheck: 'never',
    },
    memoize: lruMemoize,
    argsMemoize: lruMemoize,
    memoizeOptions: {
      resultEqualityCheck: (a: unknown, b: unknown) => {
        if (a instanceof Big && b instanceof Big) {
          return a.eq(b);
        }

        return a === b;
      },
    },
  },
);
